<div class="efile-scrubbing-container">
  <ul class="nav nav-tabs" role="tablist">
    @for (tab of tabs; track $index) {
<li class="nav-item">
      <a
        class="nav-link"
        [class.active]="isSelected(tab.key)"
        [attr.aria-current]="isSelected(tab.key) ? 'page' : null"
        tabindex="0"
        role="tab"
        (click)="selectTab(tab.key)"
        (keyup.enter)="selectTab(tab.key)"
      >
        {{ tab.label }}
      </a>
    </li>
}
  </ul>

  <div class="content-view">
    @if (hasActiveSubmission()) {

      <!--
        Mirrors the legacy ui-router behaviour
        (`submissions-dasboard.submission.efileScrubbing.<list|run|history>`
        in `efile.js` L228/L382/L508): only the active child state's content
        is in the DOM. We use a structural `*ngIf` instead of `[hidden]` so
        gizmoGrid's absolutely-positioned toolbar/scaffold can't leak from
        an inactive tab (which previously left filter bars + grids stacked
        on the same page). The grid config for each tab is still cached via
        `gridConfigByTab`, so re-mounting on tab switch reuses the same
        config object reference.
      -->
      @for (tab of tabs; track $index) {

      @if (isSelected(tab.key)) {
<div
       
        class="scrubbing-grid-host"
      >
        <!-- ===========================================================
             Run-tab filter bar (efile.js L401-453). Mirrors the admin
             `gt-filter-container` look used on the submission-list and
             form-by-submission screens so the dropdowns are visually
             consistent across the workspace. The "Form By Submission"
             multi-select uses the same `gt-multiselect-wrapper` panel
             markup as `data-filters.component.html`; the "Scrubbing
             list" single-select uses the native `gt-filter-select`.
             =========================================================== -->
        @if (tab.key === 'run') {
<div
          class="gt-filter-container scrubbing-filter-bar"
         
        >
          <div class="gt-filter-item">
            <i class="fa fa-refresh gt-refresh"
               (click)="applyActiveTabFilters()"
               title="Refresh Data"></i>
          </div>

          <div class="gt-filter-item">
            <label class="gt-filter-label">Form By Submission <span class="required">*</span></label>
            <div class="gt-multiselect-wrapper" #formMultiselectWrapper>
              <div class="gt-multiselect-btn"
                   (click)="toggleFormMenu(); $event.stopPropagation()">
                <span>Selected Forms</span>
                <i class="fa fa-caret-down"></i>
                @if (selectedForms.length > 0) {
<span class="badge">{{ selectedForms.length }}</span>
}
              </div>
              @if (formFilterUi._menuOpen) {
<div class="gt-multiselect-dropdown">
                @if (formOptions.length) {
<div class="gt-multi-actions">
                  <span (click)="selectAllForms(); $event.stopPropagation()">Select All</span>
                  <span (click)="unselectAllForms(); $event.stopPropagation()">Unselect All</span>
                </div>
}
                @if (formOptions.length) {
<input
                       type="text"
                       class="gt-multi-search"
                       placeholder="Search..."
                       [(ngModel)]="formFilterUi._searchText"
                       (click)="$event.stopPropagation()" />
}
                @if (formOptions.length) {
<ul class="gt-multi-list">
                  @for (opt of getFilteredFormOptions(); track $index) {
<li
                      (click)="toggleFormItem(opt); $event.stopPropagation()">
                    @if (isFormChecked(opt)) {
<i class="fa fa-check"></i>
}
                    <span>{{ opt.FORM }}</span>
                  </li>
}
                </ul>
}
                @if (!formOptions.length && loadingFilters[tab.key]) {
<div class="gt-multi-empty">
                  <i class="fa fa-spinner fa-spin"></i>
                  <span>Loading...</span>
                </div>
}
                @if (!formOptions.length && !loadingFilters[tab.key]) {
<div class="gt-multi-empty">
                  <i>No items available</i>
                </div>
}
              </div>
}
            </div>
          </div>

          <div class="gt-filter-item">
            <label class="gt-filter-label">Scrubbing list <span class="required">*</span></label>
            <select class="gt-filter-select"
                    [value]="selectedSearchKeyRowByTab[tab.key]?.LABEL || ''"
                    [disabled]="loadingFilters[tab.key]"
                    (change)="onSearchKeyValueChange(tab.key, $any($event.target).value)">
              <option value="">-- Select Scrubbing --</option>
              @for (opt of searchKeyOptions; track $index) {
<option [value]="opt.LABEL">
                {{ opt.LABEL }}
              </option>
}
            </select>
          </div>

          <div class="gt-filter-item filter-actions">
            <button type="button"
                    class="btn btn-xs btn-success"
                    [disabled]="loadingFilters[tab.key]"
                    (click)="applyActiveTabFilters()">Filter</button>
          </div>

          @if (loadingFilters[tab.key]) {
<div class="gt-filter-item filter-loading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Loading filters...</span>
          </div>
}
        </div>
}

        <!-- ===========================================================
             History-tab filter bar (efile.js L527-555). Same admin
             `gt-filter-container` styling as the run tab.
             =========================================================== -->
        @if (tab.key === 'history') {
<div
          class="gt-filter-container scrubbing-filter-bar"
         
        >
          <div class="gt-filter-item">
            <i class="fa fa-refresh gt-refresh"
               (click)="applyActiveTabFilters()"
               title="Refresh Data"></i>
          </div>

          <div class="gt-filter-item">
            <label class="gt-filter-label">Scrubbing list <span class="required">*</span></label>
            <select class="gt-filter-select"
                    [value]="selectedSearchKeyRowByTab[tab.key]?.LABEL || ''"
                    [disabled]="loadingFilters[tab.key]"
                    (change)="onSearchKeyValueChange(tab.key, $any($event.target).value)">
              <option value="">-- Select Scrubbing --</option>
              @for (opt of searchKeyOptions; track $index) {
<option [value]="opt.LABEL">
                {{ opt.LABEL }}
              </option>
}
            </select>
          </div>

          <div class="gt-filter-item filter-actions">
            <button type="button"
                    class="btn btn-xs btn-success"
                    [disabled]="loadingFilters[tab.key]"
                    (click)="applyActiveTabFilters()">Filter</button>
          </div>

          @if (loadingFilters[tab.key]) {
<div class="gt-filter-item filter-loading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Loading filters...</span>
          </div>
}
        </div>
}

        @if (gridConfigFor(tab.key); as cfg) {
<div
          efileGrid
          #gridRef="efileGrid"
          class="gizmo-grid"
         
          [gridConfig]="cfg"
          (gridCallback)="onGridCallback($event, gridRef)"
        ></div>
}
      </div>
}
      
}
    
} @else {

      <div class="tab-placeholder">
        <div class="tab-placeholder__hint">
          Select a submission from the Submissions list to load scrubbing data.
        </div>
      </div>
    
}

    <!-- Confirmation modal for ctrlFn plans that require it. -->
    @if (showConfirmModal) {
<gtw-confirmation-modal
     
      [config]="confirmModalConfig"
      [visible]="showConfirmModal"
      (confirmed)="onConfirmModal()"
      (cancelled)="onCancelModal()"
      (closed)="onCancelModal()"
    ></gtw-confirmation-modal>
}

    <!-- ============================================================
         Inline Add/Update Scrubbing modal (port of efile.js L274-369).
         Reuses CreateNewScrubbingComponent — the component reads
         row/submission context from WorkspaceService, so Pattern B
         deep-links work without extra wiring. We listen for its
         (request-grid-update) event ('refresh' or 'cancel') and
         translate that into a grid refresh + modal close.
         ============================================================ -->
    @if (showAddEditModal) {
<div class="add-edit-modal-overlay">
      <div class="add-edit-modal-dialog">
        <gtw-efile-create-new-scrubbing
          [rowSeed]="addEditRowData"
          (request-grid-update)="closeAddEditModal($event)"
        ></gtw-efile-create-new-scrubbing>
      </div>
    </div>
}

    
  </div>
</div>
